import axios from "axios";
import { dataEnv } from "../../config/index.js";
import { verifyRecaptcha } from './recaptcha';
const API_BASE_URL = dataEnv().API_URL;

/**
 * Function to create rule
 * @param {Object} payload
 * @return AxiosPromise
 */
export const createRule = async (ruleData) => {
  try {
    // Verificar reCAPTCHA primero
    await verifyRecaptcha(ruleData.recaptchaToken, 'create_rule');

    // Si la verificación es exitosa, proceder con la creación de la regla
    const response = await axios.post(`${API_BASE_URL}/rules`, ruleData);
    return response;
  } catch (error) {
    if (error.message === 'Verificación de reCAPTCHA fallida') {
      throw new Error('La verificación de seguridad falló. Por favor, intente nuevamente.');
    }
    throw error;
  }
};

/**
 * Function to get rule
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getRules = (clientId) => {
  return axios.get(`${API_BASE_URL}/rules/${clientId}/client?clientId=1`);
};

/**
 * Function to edit rule
 * @param {Object} payload
 * @return AxiosPromise
 */
export const editRules = (payload) => {
  return axios.patch(`${API_BASE_URL}/rules`, payload);
};

/**
 * Function to delete rule
 * @param {Object} payload
 * @return AxiosPromise
 */
export const deleteRules = (rulesId, payload) => {
  return axios.delete(`${API_BASE_URL}/rules/${rulesId}`, payload);
};

/**
 * Function to get rule detail
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getRuleDetail = (rulesId) => {
  return axios.get(`${API_BASE_URL}/rules/${rulesId}/info`);
};

/**
 * Function to get countries
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getCountries = () => {
  return axios.get(`${API_BASE_URL}/countries`);
};
